(function () {
    'use strict';

    function sessionDataService($http, $q) {
        var baseUrl = '[BuildifyApiHost]/api/session';
        var svc = this;
        svc.sessionData = null;

        function loadSession() {
            if (svc.sessionData) {
                return $q.when(svc.sessionData);
            }

            return $http.get(baseUrl).then(function (response) {
                svc.sessionData = response.data;
                return svc.sessionData;
            });
        };

        return {
            loadSession: loadSession
        }
    }

    sessionDataService.$inject = ['$http', '$q'];

    angular.module('ecap.common').service('sessionDataService', sessionDataService);
})();
